import gsap, { Power3 } from 'gsap';
import { SplitText } from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';

export class ScrollItem__Default extends VScroll_Item {
    _img;
    _titles;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setUpDefaultAnimation();

        this.onShow = () => {
            this.showAnimation();
        };
    }

    setUpDefaultAnimation() {
        this._img = GetBy.selector('figure', this.item);
        for (let i = 0; i < this._img.length; i++) {
            this._img[i].classList.add('anim');
        }

        const titles = GetBy.class('__title', this.item);
        this._titles = new SplitText(titles, { type: 'words', tag: 'span' }).words;

        this._titles.map(title => {
            title.classList.add('--text-anim');
            title.classList.add('--lime');
            gsap.set(title, { opacity: 0 });
        });
    }

    showDefaultAnimation() {
        for (let i = 0; i < this._img.length; i++) {
            gsap.delayedCall(.2 * i, () => {
                this._img[i].classList.remove('anim');
            });
        }

        this._titles.map((title, i) => {
            const delay = .3 + .1 * i;
            gsap.to(title, { opacity: 1, duration: .5, delay, ease: Power3.easeInOut });
            gsap.delayedCall(delay + .1, () => { title.classList.remove('--lime') });
        });
    }

    setUpAnimation() { }

    showAnimation() {
        this.showDefaultAnimation();
    }
}

Scroll._registerClass('Default', ScrollItem__Default);
